export default __webpack_public_path__ + "static/media/RiceFieldsMap.b60cc417.jpg";